import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };

const getProfile = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/profile/retrieve',
    headers,
    successCallback,
    errorCallback,
  );
};

const updateProfile = (payload, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/profile/update',
    headers,
    JSON.stringify(payload),
    successCallback,
    errorCallback,
  );
};

const updatePassword = (payload, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/profile/update/password',
    headers,
    JSON.stringify(payload),
    successCallback,
    errorCallback,
  );
};

const ProfileApi = { getProfile, updateProfile, updatePassword };

export default ProfileApi;



// WEBPACK FOOTER //
// ./src/apis/profile.js